import React from "react";
import ReactWOW from "react-wow";
import { $t } from './i18n';

class CardList extends React.Component {
  render() {
    const { list = [] } = this.props
    return (
      <ul className="card-wrapper">
        {
          list.map((item, index) => (
            <ReactWOW animation="fadeInUp" delay={`${index * 0.1}s`} key={item.title || index}>
              <li className="item">
                { item.icon ? <img className="img" src={require(`@/assets/images/${item.icon}`)} alt={item.icon} /> : null }
                <div className="content">
                  <p className="title">{$t(item.title)}</p>
                  {
                    Array.isArray(item.desc)
                    ? item.desc.map(desc => <p className="desc" key={desc}>{$t(desc)}</p>)
                    : <p className="desc">{$t(item.desc)}</p>
                  }
                  { item.explain ? <p className="explain">{$t(item.explain)}</p> : null}
                </div>
              </li>
            </ReactWOW>
          ))
        }
      </ul>
    );
  }
}

export default CardList;
